import {
  animate,
  AnimationTriggerMetadata,
  style,
  transition,
  trigger,
} from '@angular/animations';

export const formFieldAnimations: {
  readonly indicator: AnimationTriggerMetadata;
} = {
  indicator: trigger('indicator', [
    transition(':enter', [
      style({ width: 0 }),
      animate('300ms cubic-bezier(0.55, 0, 0.55, 0.2)'),
    ]),
  ]),
};
